<div class="dialog-content-wrapper no-overflow">
    <mat-toolbar matDialogTitle class="m-0 mb-24" set-color [backgroundColor]="subjectType.color">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title">Print {{subject?.isReferral ? 'Referral' : subjectType?.name}}</span>
            <button id="btnClosePrintDlg" mat-button class="mat-icon-button"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog"
                    tabindex="-1">
                    <mat-icon set-color [backgroundColor]="subjectType.color">close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

<div class="intro">Please select sections to include:</div>
<form class="print-options" [formGroup]="form">
    <mat-checkbox id="chkSubject" formControlName="subject" name="chksubject" matTooltip="Subject card">Subject</mat-checkbox>
    <mat-checkbox id="chkLinkedSubjects" formControlName="linkedSubjects" name="chkLinkedSubjects" matTooltip="Subjects directly linked to this subject">Linked Subjects</mat-checkbox>
    <mat-checkbox *ngIf="showAssessments" id="chkListAssessments" formControlName="assessments" name="chkAssessments" matTooltip="Assessments">Assessments</mat-checkbox>
    <mat-checkbox id="chkListLinkedMarkers" formControlName="linkedSubjectMarkers" name="chkLinkedMarkers" matTooltip="Linked Subject Markers">Linked Markers</mat-checkbox>
    <mat-checkbox id="chkListMarkers" formControlName="markers" name="chkMarkers" matTooltip="Markers">Markers</mat-checkbox>
    <mat-checkbox *ngIf="showReferrals" id="chkListReferrals" formControlName="referrals" name="chkReferrals" matTooltip="Referral">Referral</mat-checkbox>
    <mat-checkbox *ngIf="showReviews" id="chkListReviews" formControlName="reviews" name="chkReviews" matTooltip="Reviews">Reviews</mat-checkbox>
    <div fxLayout="column">
        <ng-container *ngIf="subjectType?.primary" formArrayName="processTypes">
            <div *ngFor="let processType of processTypes; let i = index">
                <mat-checkbox class="process-type-checkbox" [formControlName]="i" matTooltip="{{processType.pluralName}}">{{processType.pluralName}}</mat-checkbox>
            </div>
        </ng-container>
        <mat-checkbox *ngIf="subjectType?.primary" id="chkTasks" formControlName="tasks" name="chkTasks" matTooltip="Tasks">Tasks</mat-checkbox>
    </div>
    <mat-checkbox id="chkListAttachments" formControlName="listAttachments" name="chkListAttachments" matTooltip="List attachments attached to this subject">List Attachments</mat-checkbox>
    <mat-form-field *ngIf="form.get('listAttachments').value" color="accent" class="attachment-options">
        <input id="attachmentLabels" matInput #input class="form-control" placeholder="Labels To Include" formControlName="attachmentLabels" name="attachmentLabels">
    </mat-form-field>
    <mat-checkbox id="chkNotes" formControlName="notes" name="chkNotes" matTooltip="Notes">Notes</mat-checkbox>
    <mat-checkbox *ngIf="form.get('notes').value" class="note-options" id="chkDraft" formControlName="includeDrafts" name="chkDraft" matTooltip="Include Draft Notes">Include Drafts</mat-checkbox>
    <mat-checkbox *ngIf="form.get('notes').value" class="note-options"id="chkStarred" formControlName="onlyStarred" name="chkStarred" matTooltip="Only include Notes which are starred">Only Starred</mat-checkbox>
    <mat-checkbox *ngIf="form.get('notes').value" class="note-options"id="chkImportant" formControlName="onlyImportant" name="chkImportant" matTooltip="Only include Notes which are important">Only Important</mat-checkbox>
    <mat-checkbox *ngIf="form.get('notes').value" class="note-options" id="chkSensitive" formControlName="includeSensitive" name="chkSensitive" matTooltip="Include Sensitive Notes">Include Sensitive</mat-checkbox>
</form>

<!-- <mat-error *ngIf="validationErrors!=''" style="white-space: pre-wrap">{{ validationErrors}}</mat-error> -->
<div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
        <button mat-raised-button
                id="btnPrint"
                type="submit" 
                [disabled]="!canPrint" 
                [mat-dialog-close]="1"
                (click)="print()" 
                class="mat-accent"
                aria-label="Print">
            PRINT
        </button>
    </div>
</div>
</div>
